import { Heading } from '@doist/marketist'

import cn from 'classnames'

import css from './Heading.module.css'

export type RTHeadingProps = {
    id?: string
    tag: 'h1' | 'h2' | 'h3' | 'h4'
    children?: React.ReactNode
    className?: string
}

export function RTHeading({ tag, children, className, ...rest }: RTHeadingProps) {
    const tagClass = tag === 'h2' ? css.h2 : css.h3
    const level = tag.replace('h', '') as '1' | '2' | '3' | '4'
    return <Heading level={level} className={cn(css.heading, tagClass, className)} {...rest} />
}
